import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import type { GoodsReceiptPalletRow } from "@/graphql/codegen/graphql"

interface GoodsReceiptPalletBatchNumbersCellProps {
  goodsReceiptPalletRow: GoodsReceiptPalletRow
}

export const GoodsReceiptPalletBatchNumbersCell: FC<GoodsReceiptPalletBatchNumbersCellProps> = ({
  goodsReceiptPalletRow,
}) => {
  return (
    <Box className='flex flex-col gap-1'>
      {goodsReceiptPalletRow?.lots && goodsReceiptPalletRow?.lots.length > 0 ? (
        goodsReceiptPalletRow?.lots.map((lot) => (
          <Typography key={lot.goodsReceiptPalletRowLotId} variant='body2'>
            {lot.batchNumber || "-"}
          </Typography>
        ))
      ) : (
        <Typography variant='body2' className='text-gray-500'>
          -
        </Typography>
      )}
    </Box>
  )
}
